/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';
import { BackendCapexVariantRequestDto } from '../../models/backend-capex-variant-request-dto';

export interface EconomicIndicatorsCapexVariantsUpdate$Params {
  /**
   * A unique integer value identifying this capex variant.
   */
  id: number;
  body: BackendCapexVariantRequestDto;
}

export function economicIndicatorsCapexVariantsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsUpdate.PATH = '/api/economic_indicators/capex_variants/{id}/';
